









import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

@Component
export default class WParagraph extends Mixins(WidgetMixin, TextMixin) {
  @Prop({ type: Boolean, default: false })
  paragraph!: boolean;

  get computedTag() {
    return this.paragraph ? "p" : "span";
  }
}
